module.exports = __webpack_public_path__ + "media/images/iconSearch__errorRed--dark-e8cc3c4f8d8913d9917627a70526be77.png";